import React from 'react'
import { useParams } from 'react-router-dom'
import { RegistrationEditFeature } from 'features/registration/registration-edit'

export default function MemberRegistrationEditPage() {
  const { id } = useParams<{ id: string }>()
  return <RegistrationEditFeature id={id} />
}
